/** Problems panel showing parsed LaTeX errors/warnings. */

import type { LatexError } from "../types";

interface Props {
  errors: LatexError[];
  onJump: (file: string, line: number | null) => void;
}

export function ProblemsPanel({ errors, onJump }: Props): JSX.Element {
  if (errors.length === 0) {
    return <div className="empty">No problems detected.</div>;
  }
  return (
    <div className="problems">
      {errors.map((err, i) => (
        <div
          key={i}
          className="problem"
          onClick={() => onJump(err.file, err.line)}
        >
          <span className={`sev ${err.severity}`}>
            {err.severity === "error" ? "✕" : "⚠"}
          </span>
          <span className="loc">
            {err.file}
            {err.line != null ? `:${err.line}` : ""}
          </span>
          <span>{err.message}</span>
        </div>
      ))}
    </div>
  );
}
